export const REGISTRATION_FEEDBACK_SURVEY_TRIGGER = "CustomerRegistration" as const;
export const REGISTRATION_FEEDBACK_PLATFORM = "ACP" as const;

export type RegistrationFeedbackMetadata = {
  email: string;
  userUUID: string;
  loanNumber: string;
};

export type RegistrationFeedbackApiPayload = {
  QID1: number;
  QID9_TEXT: string;
  UserUUID: string;
  LoanNumber: string;
  SurveyTrigger: typeof REGISTRATION_FEEDBACK_SURVEY_TRIGGER;
  Platform: typeof REGISTRATION_FEEDBACK_PLATFORM;
  Email: string;
  OS: string;
  Device: string;
  FullstoryUrl: string;
};
